module.exports = __webpack_public_path__ + "media/assets/images/layout/img-front-bg-2085a76f992dbcd43c31bf33f884fc1e.jpg";